// eslint-disable-next-line @typescript-eslint/no-explicit-any
type AnyHandler = (payload: any) => void;

export class EventBus {
  private listeners = new Map<string, Set<AnyHandler>>();

  on(event: string, handler: AnyHandler): () => void {
    if (!this.listeners.has(event)) this.listeners.set(event, new Set());
    this.listeners.get(event)!.add(handler);
    return () => this.off(event, handler);
  }

  off(event: string, handler: AnyHandler): void {
    this.listeners.get(event)?.delete(handler);
  }

  once(event: string, handler: AnyHandler): () => void {
    const off = this.on(event, (payload) => {
      off();
      handler(payload);
    });
    return off;
  }

  emit(event: string, payload?: unknown): void {
    this.listeners.get(event)?.forEach((h) => {
      try {
        h(payload);
      } catch (err) {
        console.error(`EventBus[${event}] handler error:`, err);
      }
    });
  }

  dispose(): void {
    this.listeners.clear();
  }
}
